import axios from 'axios';
import EndPoint from 'Api/EndPoint';

const axiosInstance = axios.create({
  baseURL: EndPoint.Host,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosInstance.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['x-access-token'] = token;
    }
    return config;
  },
  error => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401 && (error.response.data.message === 'jwt expired' || error.response.data === 'UN_AUTHORIZED_ADMIN_IP')) {
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
